export enum MeetDomainEvents {
    notLoadedTenant = 'not_loaded_tenant',
    loadedTenant = 'loaded_tenant',
    notRetrievedMeet = 'not_retrieved_meet',
    retrieveMeet = 'retrieve_meet',
    retrievedMeet = 'retrieved_meet',
    alreadyRetrievedMeet = 'already_retrieved_meet',
    professionalAvailable = 'professional_available',
    patientAvailable = 'patient_available',
    unavailableMeet = 'unavailable_meet',
    invalidCode = 'invalid_code',
    alreadyFinishedMeet = 'already_finished_meet',
    tooEarlyAccess = 'too_early_access',
    waitingRoomAccess = 'waiting_room_access',
    waitingRoomReady = 'waiting_room_ready',
    roomAccess = 'room_access',
    feedbackPage = 'feedback_page',
    finishPage = 'finish_page',

    cantSendPatientWaiting = 'cant_send_patient_waiting',
    patientWaitingSending = 'patient_waiting_sending',
    patientWaitingSent = 'patient_waiting_sent',
    patientWaitingSendingFailed = 'patient_waiting_sending_failed',

    cantSendProfessionalJoined = 'cant_send_professional_joined',
    professionalJoinedSending = 'professional_joined_sending',
    professionalJoinedSent = 'professional_joined_sent',
    professionalJoinedSendingFailed = 'professional_joined_sending_failed',

    feedbackSending = 'feedback_sending',
    feedbackSent = 'feedback_sent',
    feedbackSendFailed = 'feedback_send_failed',
    feedbackAlreadyRegistered = 'feedback_already_registered',

    copyMeetLinkToClipboardFailed = 'copy_meet_link_to_clipboard_failed',

    hangUpAndFinish = 'hang_up_and_finish',
    hangedUpAndFinished = 'hanged_up_and_finished',
    hangUpAndFinishFailed = 'hang_up_and_finish_failed',
    forcedToFinish = 'forced_to_finish',

    refreshMeet = 'refresh_meet',
    refreshedMeet = 'refreshed_meet',
    refreshMeetFailed = 'refresh_meet_failed',
}